// @ts-ignore
import packageInfo from '../../package.json';
export const environment = {
  production: true,
  apiUrl: 'https://api-vendor.aclarian.com/api/',
  baseUrl: 'https://nw7avecra-vendor.aclarian.com',
  appName: 'Northwest 7th Ave Corridor CRA | VendorV2',
  tokenizationKey: 'PaQmTu-VE6uUF-9V6acY-jecjXr',
  datadogClientToken: 'pubed817bd29658a8212e37257c4e2082d4',
  datadogApplicationId: '5c511ec6-f0b8-4c7a-8d7b-58ea209732b5',
  datadogService: 'Invoicing_N7SC_PROD',
  ApiKey: 'U!VMlnHrgU5BSKFt',
  env: 'PROD',
  version: packageInfo.version,
};
